(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("select", [], factory);
	else if(typeof exports === 'object')
		exports["select"] = factory();
	else
		root["select"] = factory();
})(this, function() {
return 